import type { Ingredient, Locale } from "./types";

export function normalizeIngredientSearch(value: string): string {
  return (
    value
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      // Dotless Turkish i (U+0131) has no NFKD decomposition and isn't a-z, so
      // without this it would be silently dropped by the ASCII strip below
      // instead of folding to "i" (e.g. "kirmizi biber" would become "k rm z biber").
      .replace(/\u0131/g, "i")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
  );
}

export function ingredientMatchesSearch(
  ingredient: Ingredient,
  normalizedQuery: string,
  locale: Locale = "en",
): boolean {
  if (!normalizedQuery) return true;
  // A Turkish-locale user searches against the Turkish name/aliases shown in
  // the list, not the English source fields; fall back to English when this
  // ingredient hasn't been translated yet (see docs/adr/0002-i18n-english-turkish.md).
  const searchValues =
    locale === "tr" && ingredient.translations
      ? [ingredient.translations.tr.name, ...ingredient.translations.tr.aliases]
      : [ingredient.name, ...ingredient.aliases];
  return searchValues.some((value) =>
    normalizeIngredientSearch(value).includes(normalizedQuery),
  );
}
